import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ClaudeResponse, type Message } from 'src/app/01_pages/07_chat/message'
import { Observable } from 'rxjs'
import { ExecutePostAPI } from '../apis/execute_api-calls'

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private readonly api = '/api/chat'

  private messageStack: Message[] = []

  constructor (private readonly http: HttpClient) {}

  async submitMessages (messages: Message[]) {
    this.messageStack = messages
    return await this.sendMessagesToApi()
  }

  async sendMessagesToApi () {
    const path = '/chat_bot/roi'
    const messages = {
      success: 'Successfully received the chat bot messages.',
      error: 'Error receiving the chat bot messages.',
      showSuccessToast: false
    }
    const data = {
      messages: this.messageStack.map(msg => {
        return {
          role: msg.role,
          content: msg.content
        }
      })
    }
    const response = await ExecutePostAPI(path, this, data, messages)
    console.log('response', response)
    return response.data
  }

  wipeMessages () {
    this.messageStack = []
  }
}
